// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2wkC2","disabled":"FileBtn_disabled__3ALSU","warn":"FileBtn_warn__vq3eB","fade":"FileBtn_fade__iItNy"};